import { FC, useState } from 'react';

import Link from 'next/link';
import router from 'next/router';

import { Button, MenuItem, Menu } from '@mui/material';

import { useRecoilValue } from 'recoil';

import { adminLoginUserDataAtom } from '@recoil_iqfu/atoms/auth/adminLoginUserData';
import { companyLoginUserDataAtom, companyLoginUserDataSelector } from '@recoil_iqfu/atoms/auth/companyLoginUserData';
import { finanialAgencyLoginUserDataAtom } from '@recoil_iqfu/atoms/auth/financialAgencyLoginUserData';

import { UserType } from '@constants_common';
import { useAuth } from '@contexts_common/authContext';

import styles from './UserButton.module.scss';

type Props = {
  userType: UserType;
  isChat?: boolean;
};

const UserButton: FC<Props> = ({ userType, isChat }) => {
  const { logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const adminLoginUserData = useRecoilValue(adminLoginUserDataAtom);
  const companyLoginUserData = useRecoilValue(companyLoginUserDataAtom);
  const financialAgencyLoginUserData = useRecoilValue(finanialAgencyLoginUserDataAtom);
  const { isMultipleCompanyUser } = useRecoilValue(companyLoginUserDataSelector);

  const userName =
    userType === 'company'
      ? companyLoginUserData?.name
      : userType === 'admin'
      ? adminLoginUserData?.name
      : userType === 'financial_agency'
      ? financialAgencyLoginUserData?.name
      : '';

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const logoutAction = () => {
    handleClose();

    logout(userType);
  };

  const serviceList = companyLoginUserData?.services;
  const hasIqfuService = serviceList?.includes('iqfu');

  return (
    <div className={styles.header_area}>
      <div className={`${styles.container} ${isChat && styles.position_chat}`}>
        {userType === 'company' && !isMultipleCompanyUser && (
          <div className={styles.company_name}>{companyLoginUserData?.company_details?.[0].name}</div>
        )}
        {userType === 'company' && isMultipleCompanyUser && (
          <div className={styles.company_name}>複数店舗ログイン用アカウント</div>
        )}
        <div className={styles.user_button}>
          <Button
            color="inherit"
            className={styles.user_name}
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            <img src="/images/iqfu/dashboard/user_icon.svg" alt="ユーザーアイコン" className={styles.user_icon} />
            {userName}
          </Button>

          <Menu open={open} anchorEl={anchorEl} onClose={handleClose} className={styles.menu}>
            {userType === 'company' && hasIqfuService && (
              <MenuItem disabled={router.pathname === `/console/company/account`}>
                <Link href={`/console/company/account`} prefetch={false} passHref>
                  <a>アカウント情報</a>
                </Link>
              </MenuItem>
            )}
            <MenuItem onClick={logoutAction}>ログアウト</MenuItem>
          </Menu>
        </div>
      </div>
    </div>
  );
};

export default UserButton;
